// extracted by mini-css-extract-plugin
module.exports = {"root":"Hashtags_root__2dEeQ","wrapper":"Hashtags_wrapper__tx_Xq","header":"Hashtags_header__3nZ12","content":"Hashtags_content__1U9X5"};